import { render } from "./toolbarManager.vue?vue&type=template&id=3a37170b"
import script from "./toolbarManager.vue?vue&type=script&lang=js"
export * from "./toolbarManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__